// extracted by mini-css-extract-plugin
export default {"messageContainer":"ewhHNAno"};